import * as gConst from 'services/constants';

export const LABEL_LIST = [
  //──── index sensitive
  'consultation_booked', // 0
  'consultation_canceled', // 1
  'arrived', // 2
  'consultation_in_progress', // 3
  'to_radiology', // 4
  'from_radiology', // 5
  'consultation_finished', // 6
  'consultation_paid', // 7
  'consultation_nowshow', // 8
  'consultation_restarted' // 9
];

const UI_STATUS_LIST = [
  // 0 booked
  {
    ui_status: LABEL_LIST[0],
    conditions: gConst.STATUS_BOOKED
  },
  // 1 canceled
  {
    ui_status: LABEL_LIST[1],
    conditions: gConst.STATUS_CANCELLED
  },
  // 2 arrived
  {
    ui_status: LABEL_LIST[2],
    conditions: [gConst.STATUS_ARRIVED, gConst.STATUS_SELF_ARRIVED]
  },
  // 3 consultation_in_progress
  {
    ui_status: LABEL_LIST[3],
    conditions: [
      gConst.STATUS_STARTED,
      gConst.STATUS_CONSULTATION_RESTARTED,
      gConst.STATUS_SUSPENDED,
      gConst.STATUS_CONSULTATION_STARTED_AFTER_RADIOLOGY
    ]
  },
  // 4 to radiology
  {
    ui_status: LABEL_LIST[4],
    conditions: [gConst.STATUS_RADIOLOGY_STARTED, gConst.STATUS_RADIOLOGY_STARTED_DURING]
  },
  // 5 from radiology
  {
    ui_status: LABEL_LIST[5],
    conditions: gConst.STATUS_RADIOLOGY_FINISHED
  },
  // 6 finished
  {
    ui_status: LABEL_LIST[6],
    conditions: gConst.STATUS_FINISHED
  },
  // 7 paid
  {
    ui_status: LABEL_LIST[7],
    conditions: gConst.STATUS_PAID
  },
  // 8 no show
  {
    ui_status: LABEL_LIST[8],
    conditions: gConst.STATUS_NO_SHOW
  },
  // 9 from radiology during
  {
    ui_status: LABEL_LIST[9],
    conditions: gConst.STATUS_RADIOLOGY_FINISHED_DURING
  }
];

export const convertAppointmentStatusForUI = appointment => {
  const viewState =
    appointment &&
    appointment.appointment &&
    appointment.appointment.viewModel &&
    appointment.appointment.viewModel.state;

  const statusObj = UI_STATUS_LIST.find(
    item => item && String(item.conditions).indexOf(viewState) > -1
  );
  return statusObj && statusObj.ui_status;
};

export const convertStatusToRowClass = appointment => {
  switch (convertAppointmentStatusForUI(appointment)) {
    case LABEL_LIST[0]:
      return 'booked';
    case LABEL_LIST[1]:
      return 'cancelled';
    case LABEL_LIST[2]:
      return 'arrived';
    case LABEL_LIST[3]:
      return 'in-progress';
    case LABEL_LIST[4]:
      return 'to-radiology';
    case LABEL_LIST[5]:
      return 'from-radiology';
    case LABEL_LIST[6]:
      return 'finished';
    case LABEL_LIST[7]:
      return 'paid';
    case LABEL_LIST[9]:
      return 'restart-consultation';
    default:
      return '';
  }
};
